import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { TextField, Button, Typography, Paper } from '@material-ui/core'
import FileBase from 'react-file-base64'
import useStyles from './styles'
import { createPost, updatePost } from '../../actions/posts'

const Form =({currentId, setCurrentId}) => {
  const classes = useStyles()
  const [postData, setPostData] = useState({ creator: '', title: '', message: '', tags: '', selectedFile: ''})
  const post = useSelector((state) => currentId ? state.posts.find((post) => post._id === currentId) : null) 
  const dispatch = useDispatch()

  useEffect(() => {
    if(post) setPostData(post);
  }, [post])

  const handleChange = (e) => {
    setPostData({...postData, [e.target.name]: e.target.value})
  }
 
  const handleSubmit = (e) => {
    e.preventDefault()
    if (currentId) {
      dispatch(updatePost(currentId, postData))
    } else {
      dispatch(createPost(postData))
    }
    clear()
  }
  
  const clear = () => {
    setCurrentId(null)
    setPostData({ creator: '', title: '', message: '', tags: '', selectedFile: ''})
  }
  return (
    <Paper className={classes.paper}>
      <form autoComplete='off' noValidate className={`${classes.root} ${classes.form}`} onSubmit={handleSubmit} >
        <Typography variant='h6'>{currentId? 'Editing' : 'Creating'} a Memory</Typography>
        <TextField name='creator' variant='outlined' label='Creator' fullWidth value={postData.creator} onChange={handleChange} />
        <TextField name='title' variant='outlined' label='Title' fullWidth value={postData.title} onChange={handleChange} />
        <TextField name='message' variant='outlined' label='Message' fullWidth value={postData.message} onChange={handleChange} />
        <TextField name='tags' variant='outlined' label='Tags' fullWidth value={postData.tags} onChange={(e) => setPostData({...postData, tags: e.target.value.split(',')})} />
        <div className={classes.fileInput}>
          <FileBase type='file' multiple={false} onDone={({base64}) => setPostData({...postData, selectedFile: base64})} />
        </div>
        <Button className={classes.buttonSubmit} variant='contained' color='' size='large' type='submit' fullWidth>Submit</Button>
        <Button variant='contained' color='secondary' size='small' onClick={clear} fullWidth>Clear</Button>
      </form>
    </Paper>
  )
}

export default Form